import { InvestingPersonEnum, RetirementAccountEnum } from 'interfaces'
import moment from 'moment'
import React from 'react'
import { ToWords } from 'to-words'
import { formatNumber, maskNumbersExceptLastFour, maskSSN } from 'utils'
import { removeOnly } from './Modals/SubscriptionAgreementModal'

const toWords = new ToWords({
  localeCode: 'en-IN',
  converterOptions: {
    currency: true,
    ignoreDecimal: false,
    ignoreZeroCurrency: false,
    doNotAddOnly: false,
    currencyOptions: {
      // can be used to override defaults for the selected locale
      name: 'Dollar',
      plural: 'Dollars',
      symbol: '$',
      fractionalUnit: {
        name: 'Cent',
        plural: 'Cents',
        symbol: '',
      },
    },
  },
})

interface SubscriptionAgreemenPdfProps {
  getValues: any
}

const SubscriptionAgreemenPdf = ({ getValues }: SubscriptionAgreemenPdfProps) => {
  const currentDate = moment()
  const sharePrice = Number(process.env.REACT_APP_SHARE_PRICE)

  return (
    <div className="">
      <div className="mx-6 flex items-center justify-center">
        <div className=" bg-white">
          <div className="pb-5">
            <div className="text-xl font-bold">SUBSCRIPTION AGREEMENT</div>

            <div className="flex">
              {getValues('investingProfile.option') === InvestingPersonEnum.JOINTLY && (
                <div>
                  <div className="flex">
                    Name of First Investor:{' '}
                    <p className="ml-3 font-bold">
                      {getValues('basicInfo.firstName')} {getValues('basicInfo.middleName')}{' '}
                      {getValues('basicInfo.lastName')} {getValues('basicInfo.suffix')}
                    </p>
                  </div>
                  <div className="flex">
                    Name of Second Investor:{' '}
                    <p className="ml-3 font-bold">
                      {getValues('secondary.basicInfo.firstName')} {getValues('secondary.basicInfo.middleName')}{' '}
                      {getValues('secondary.basicInfo.lastName')} {getValues('secondary.basicInfo.suffix')}
                    </p>
                  </div>
                </div>
              )}
              {getValues('investingProfile.option') !== InvestingPersonEnum.JOINTLY && (
                <>
                  Name of Investor:{' '}
                  <p className="ml-3 font-bold">
                    {getValues('basicInfo.firstName')} {getValues('basicInfo.middleName')}{' '}
                    {getValues('basicInfo.lastName')} {getValues('basicInfo.suffix')}
                  </p>
                </>
              )}
            </div>

            <div className="mt-4 flex">
              <p className="font-normal">Alan Beal</p>
            </div>

            <div className="flex">
              <p className="font-normal">Chief Executive Officer</p>
            </div>

            <div className="flex">
              <p className="font-normal">Armed Forces Brewing Company, Inc.</p>
            </div>

            <div className="flex">
              <p className="font-normal">211 W 24th St </p>
            </div>

            <div className="flex">
              <p className="font-normal">Norfolk, VA 23517 </p>
            </div>

            <div className="mt-4">
              Offering of up to $5,000,000.00 through the sale of 400,000 Shares of Non-Voting Class C Common Stock (the
              “Shares”)
            </div>

            <div className="mt-4 text-justify">
              1. Subscription. The undersigned hereby tenders this subscription and applies to purchase the number of
              Shares in Armed Forces Brewing Company, Inc., a Delaware corporation (the “Company”) indicated below,
              pursuant to the terms of this Subscription Agreement. The purchase price of each Share is{' '}
              {removeOnly(toWords.convert(sharePrice)) + ' '}
              (${formatNumber(sharePrice)}) payable in full upon subscription. The undersigned further sets forth
              statements upon which you may rely to determine the suitability of the undersigned to purchase the Shares.
              The undersigned understands that the Shares are being offered pursuant to the Offering Circular (the
              “Offering Circular”). In connection with this subscription, the undersigned represents and warrants that
              the personal, business and financial information provided to the Company along with this Subscription
              Agreement and/or through any online website is complete and accurate, and presents a true statement of the
              undersigned&apos;s financial condition.
            </div>

            <div className="mt-4 text-justify">
              2. Representations and Understandings. The undersigned hereby makes the following representations,
              warranties and agreements and confirms the following understandings:
            </div>

            <div className="pl-10">
              <div className="mt-4 text-justify">
                (i) The undersigned has received a copy of the Offering Circular, has been given the opportunity to read
                and review it carefully, and has had an opportunity to question representatives of the Company and to
                obtain such additional information concerning the Company as the undersigned requested. All questions of
                the undersigned have been satisfactorily answered prior to making this investment.
              </div>
              <div className="mt-4 text-justify">
                (ii) The undersigned has sufficient experience in financial and business matters to be capable of
                utilizing such information to evaluate the merits and risks of the undersigned&apos;s investment, and to
                make an informed decision relating thereto; or the undersigned has utilized the services of his, her or
                its financial advisor or other investment representative and together they have sufficient experience in
                financial and business matters that they are capable of utilizing such information to evaluate the
                merits and risks of the undersigned&apos;s investment, and to make an informed decision relating
                thereto.
              </div>
              <div className="mt-4 text-justify">
                (iii) The undersigned has evaluated the risks of this investment in the Company, including those risks
                particularly described in the Offering Circular, and has determined that the investment is suitable for
                him, her or it. The undersigned has adequate financial resources for an investment of this character,
                and at this time could bear a complete loss of this investment. The undersigned understands that any
                projections or other forward-looking statements that were made in the Offering Circular or otherwise
                provided to the undersigned are mere estimates and may not reflect the actual results of the
                Company&apos;s operations. The undersigned understands that the Use of Proceeds made in the Offering
                Circular are estimates, are not binding, and are subject to the Company&apos;s discretion, and may not
                reflect the actual use of proceeds by the Company of the funds they receive from this Offering and from
                your investment.
              </div>
              <div className="mt-4 text-justify">
                (iv) The undersigned understands that the Shares are not being registered under the Securities Act of
                1933, as amended (the "1933 Act") on the ground that the issuance thereof is exempt under Regulation A
                of Section 3(b) of the 1933 Act, and that reliance on such exemption is predicated in part on the truth
                and accuracy of the undersigned's representations and warranties, and those of the other purchasers of
                Shares.
              </div>
              <div className="mt-4 text-justify">
                (v) The undersigned understands that the Shares are not being registered under the securities laws of
                certain states on the basis that the issuance thereof is exempt as an offer and sale not involving a
                registerable public offering in such state, since the Shares are “covered securities” under the National
                Securities Market Improvement Act of 1996 and/or are exempt from such registration under Regulation A.
                The undersigned understands that reliance on such exemptions is predicated in part on the truth and
                accuracy of the undersigned&apos;s representations and warranties and those of other purchasers of
                Shares. The undersigned covenants not to sell, transfer or otherwise dispose of a Share unless such
                Share has been registered under the applicable state securities laws, or an exemption from registration
                is available.
              </div>
              <div className="mt-4 text-justify">
                (vi) The amount of this investment by the undersigned does not exceed 10% of the greater of the
                undersigned's net worth, not including the value of his/her primary residence, or his/her annual income
                in the prior full calendar year, as calculated in accordance with Rule 501 of Regulation D promulgated
                under Section 4(a)(2) of the Securities Act of 1933, as amended, unless the undersigned is an
                "accredited investor," as that term is defined in Rule 501 of Regulation D promulgated under Section
                4(a)(2) of the Securities Act of 1933, as amended, or is the beneficiary of a fiduciary account, or, if
                the fiduciary of the account or other party is the donor of funds used by the fiduciary account to make
                this investment, then such donor, who meets the requirements of net worth, annual income or criteria for
                being an "accredited investor."
              </div>
              <div className="mt-4 text-justify">
                (vii) The undersigned has no need for any liquidity in this investment and is able to bear the economic
                risk of this investment for an indefinite period of time. The undersigned has been advised and is aware
                that: (a) there is no public market for the Shares and a public market for the Shares may not develop;
                (b) it may not be possible to liquidate this investment readily; and (c) the Shares have not been
                registered under the Securities Act of 1933 and applicable state law and an exemption from registration
                for resale may not be available.
              </div>
              <div className="mt-4 text-justify">
                (viii) All contacts and contracts between the undersigned and the Company regarding the offer and sale
                to him of Shares have been made within the state or jurisdiction indicated below his, her or its
                signature on the signature page of this Subscription Agreement and the undersigned is a resident of such
                state or jurisdiction.
              </div>
              <div className="mt-4 text-justify">
                (ix) The undersigned has relied upon the Offering Circular, other material provided by the Company and
                independent investigations made by him or her or his or her representatives and advisors with respect to
                the Shares subscribed for herein, and no oral or written representations beyond the Offering Circular or
                other material provided by the Company have been made to the undersigned or relied upon by the
                undersigned by the Company, its representatives or assigns, or any other person or entity.
              </div>
              <div className="mt-4 text-justify">
                (x) The undersigned agrees not to transfer or assign this subscription or any interest therein.
              </div>
              <div className="mt-4 text-justify">
                (xi) The undersigned hereby acknowledges and agrees that, except as may be specifically provided herein,
                the undersigned is not entitled to withdraw, terminate or revoke this subscription.
              </div>
              <div className="mt-4 text-justify">
                (xii) If the undersigned is a partnership, corporation, limited liability company or trust, it has been
                duly formed, is validly existing, has full power and authority to make this investment, and has not been
                formed for the specific purpose of investing in the Shares. This Subscription Agreement and all other
                documents executed in connection with this subscription for Shares are valid, binding and enforceable
                agreements of the undersigned.
              </div>
              <div className="mt-4 text-justify">
                (xiii) The undersigned meets any additional suitability standards and/or financial requirements that may
                be required in the jurisdiction in which he, she or it resides, or is purchasing in a fiduciary capacity
                for a person or account meeting such suitability standards and/or financial requirements, and is not a
                minor. The undersigned has received a copy of the Offering Circular, has been given the opportunity to
                read the section of the Offering Circular entitled “Investor Eligibility Standards” and hereby agrees to
                comply with all requirements of the USA PATRIOT Act and all other know-your-customer and
                anti-money-laundering laws and regulations. Furthermore, the undersigned hereby makes the
                representations set out in paragraphs (1) – (4) of the section of the “Investor Eligibility Standards”
                of the Offering Circular.
              </div>
              <div className="mt-4 text-justify">
                (xiv) The undersigned consents to, and agrees to be bound by all the terms of the bylaws of the Company,
                including but not limited to, any restrictions on voting rights and/or any transfer restrictions
                contained in said bylaws.
              </div>
            </div>

            <div className="mt-4 text-justify">
              3. Payment arrangements. Payment for the Shares shall be received into a holding account from the
              undersigned by transfer of immediately available funds or other means approved by the Company at least two
              days prior to the applicable closing, in the amount as set forth on the signature page hereto. Upon such
              closing, the holding account shall release such funds to the Company.
            </div>

            <div className="mt-4 text-justify">
              4. Issuer-Directed Offering; No Underwriter. The undersigned understands that the offering is being
              conducted by the Company directly (issuer-directed) and the Company has not engaged a selling agent such
              as an underwriter or placement agent. The undersigned acknowledges and agrees that Cultivate Capital Group
              LLC has been engaged to serve as an accommodating broker-dealer and to provide certain technology and
              transaction facilitation. Cultivate Capital Group LLC is not participating as an underwriter. The
              undersigned acknowledges that Cultivate Capital Group LLC has neither solicited your investment in the
              Company, recommended the Shares, provided any advice, including investment advice, nor is Cultivate
              Capital Group LLC distributing the Offering Circular or making any oral representations concerning the
              offering. Cultivate Capital Group LLC has not and will not conduct extensive due diligence of this
              offering and the undersigned should not rely on Cultivate Capital Group LLC's involvement in this offering
              as any basis for a belief that it has done extensive due diligence.
            </div>

            <div className="mt-4 text-justify">
              5. Foreign Investors. If the undersigned is not a United States person (as defined by Section 7701(a)(30)
              of the Internal Revenue Code of 1986, as amended), the undersigned hereby represents that he or she has
              satisfied himself or herself as to the full observance of the laws of its jurisdiction in connection with
              any invitation to subscribe for the Shares or any use of this Subscription Agreement, including (i) the
              legal requirements within its jurisdiction for the purchase of the Shares, (ii) any foreign exchange
              restrictions applicable to such purchase, (iii) any governmental or other consents that may need to be
              obtained, and (iv) the income tax and other tax consequences, if any, that may be relevant to the
              purchase, holding, redemption, sale, or transfer of the Shares. The undersigned’s subscription and payment
              for and continued beneficial ownership of the Shares will not violate any applicable securities or other
              laws of the undersigned’s jurisdiction.
            </div>

            <div className="mt-4 text-justify">
              6. Valuation. The undersigned acknowledges that the price of the Shares was set by the Company on the
              basis of the Company’s internal valuation and no warranties are made as to value. The undersigned further
              acknowledges that future offerings of securities by the Company may be made at lower valuations, with the
              result that the undersigned’s investment will bear a lower valuation.
            </div>

            <div className="mt-4 text-justify">
              7. Indemnification. The undersigned hereby agrees to indemnify and hold harmless the Company and all of
              its affiliates, attorneys, accountants, employees, officers, directors, broker-dealers, placement agents,
              shareholders and other agents from any liability, claims, costs, damages, losses or expenses incurred or
              sustained by them as a result of the undersigned’s representations and warranties herein or otherwise
              being untrue or inaccurate, or because of a breach of this agreement by the undersigned. The undersigned
              hereby further agrees that the provisions of Section 7 of this Subscription Agreement will survive the
              sale, transfer or any attempted sale or transfer of all or any portion of the Shares. The undersigned
              hereby grants to the Company the right to setoff against any amounts payable by the Company to the
              undersigned, for whatever reason, of any and all damages, costs and expenses (including, but not limited
              to, reasonable attorney’s fees) which are incurred by the Company or any of its affiliates as a result of
              matters for which the Company is indemnified pursuant to Section 7 of this Subscription Agreement.
            </div>

            <div className="mt-4 text-justify">
              8. Taxpayer Identification Number/Backup Withholding Certification. Unless a subscriber indicates to the
              contrary on the Subscription Agreement, he, she or it will certify that his taxpayer identification number
              is correct and, if not a corporation, IRA, Keogh, or Qualified Trust (as to which there would be no
              withholding), he is not subject to backup withholding on interest or dividends. If the subscriber does not
              provide a taxpayer identification number certified to be correct or does not make the certification that
              the subscriber is not subject to backup withholding, then the subscriber may be subject to twenty-eight
              percent (28%) withholding on interest or dividends paid to the holder of the Shares.
            </div>

            <div className="mt-4 text-justify">
              9. Governing Law. This Subscription Agreement will be governed by and construed in accordance with the
              laws of the State of Delaware. The exclusive venue for any legal action under this Agreement will be in
              the proper forum in the State of Virginia. This clause does not apply to claims brought to enforce any
              duty or liability created by the Securities Act of 1933 or the Securities Exchange Act of 1934, or the
              rules and regulations thereunder, nor does it apply to purchasers in secondary transactions.
            </div>

            <div className="mt-4 text-justify">
              10. Consent to Contact. The undersigned grants permission to the Company and its employees, agents, and
              assigns, as well as Cultivate Capital Group LLC and its employees, agents, and assigns, to contact the
              undersigned via electronic communications including, but not limited to, e-mail, text message/SMS,
              telephone calls and other means of electronic messaging for purposes of facilitating or finalizing this
              investment, and for any other matters including the Company’s marketing efforts. The undersigned may opt
              out of this consent at any time by providing the Company with written communication evidencing the
              withdrawal of such permission.
            </div>

            <div className="mt-4 text-justify">
              11. Electronic Signature and Communications Notice and Consent. The undersigned and the Company hereby
              consent and agree that electronically signing this Subscription Agreement constitutes his/her/its
              signature, acceptance and agreement as if actually signed by the undersigned in writing. Further, the
              undersigned and the Company agree that no certification authority or other third party verification is
              necessary to validate any electronic signature; and that the lack of such certification or third party
              verification will not in any way affect the enforceability of any signature or resulting contract between
              the undersigned and the Company. The undersigned and the Company understand and agree that their
              e-signature executed in conjunction with the electronic submission of this Subscription Agreement shall be
              legally binding. The undersigned and the Company agree that their electronic signatures are the legal
              equivalent of their manual signature on this Agreement and consent to be legally bound by the Subscription
              Agreement’s terms and conditions. Furthermore, each party hereby agrees that all current and future
              notices, confirmations and other communications regarding this Subscription Agreement specifically, and
              future communications in general between the parties, may be made by email, sent to the email address of
              provided by the undersigned in the investor application process or as otherwise from time to time changed
              or updated and disclosed to the Company, without necessity of confirmation of receipt, delivery or
              reading, and such form of electronic communication is sufficient for all matters regarding the
              relationship between the undersigned and the Company. If any such electronically-sent communication fails
              to be received for any reason, including but not limited to such communications being diverted to the
              recipient’s spam filters by the recipient’s email service provider, or due to a recipient’s change of
              address, or due to technology issues by the recipient’s service provider, the parties agree that the
              burden of such failure to receive is on the recipient and not the sender, and that the sender is under no
              obligation to resend communications via any other means, including but not limited to postal service or
              overnight courier, and that such communications shall for all purposes, including legal and regulatory, be
              deemed to have been delivered and received. No physical, paper documents will be sent to or by the
              Company, and if the undersigned desires physical documents then the undersigned agrees to directly and
              personally print, at the undersigned’s expense, the electronically-sent communication(s) and maintaining
              such physical records in any manner or form that the undersigned desires.
            </div>

            <div className="mt-4 text-justify">
              12. Acknowledgement of Risks Factors. The undersigned has carefully reviewed and thoroughly understands
              the risks associated with an investment in the Shares as described in the Offering Circular. The
              undersigned acknowledges that this investment entails significant risks.
            </div>

            <div className="mt-4">
              The undersigned has (have) executed this Subscription Agreement on {currentDate.format('MMMM')}{' '}
              {currentDate.format('D')}, {currentDate.format('YYYY')}.
            </div>

            <div className="flex">
              {getValues('investingProfile.option') !== InvestingPersonEnum.RETIREMENT && (
                <div>
                  <div>
                    <div className="mt-6 text-xl font-bold">
                      {' '}
                      {getValues('investingProfile.option') === InvestingPersonEnum.IN_BEHALF_OF_AN_ENTITY
                        ? 'AUTHORIZED PERSON '
                        : 'SUBSCRIBER'}
                    </div>
                    <div className="mt-2 font-alexBrush text-4xl font-bold">
                      {getValues('basicInfo.firstName')} {getValues('basicInfo.middleName')}{' '}
                      {getValues('basicInfo.lastName')} {getValues('basicInfo.suffix')}
                    </div>
                    <div>
                      {' '}
                      {getValues('investingProfile.option') === InvestingPersonEnum.IN_BEHALF_OF_AN_ENTITY
                        ? 'Authorized Person Signature'
                        : 'Signature'}
                    </div>
                  </div>

                  <div className="mt-2">
                    <div className="mt-2 text-xl">
                      {getValues('basicInfo.firstName')} {getValues('basicInfo.middleName')}{' '}
                      {getValues('basicInfo.lastName')} {getValues('basicInfo.suffix')}
                    </div>
                    <div className="">
                      {getValues('investingProfile.option') === InvestingPersonEnum.IN_BEHALF_OF_AN_ENTITY
                        ? 'Printed Name of Authorized Person '
                        : 'Subscriber'}
                    </div>

                    <div className="mt-2 text-xl">{getValues('addressInfo.Street1')}</div>
                    <div className="">
                      {getValues('investingProfile.option') === InvestingPersonEnum.IN_BEHALF_OF_AN_ENTITY
                        ? 'Street Address of Authorized Person'
                        : `Investor's Address`}
                    </div>

                    {getValues('investingProfile.option') === InvestingPersonEnum.IN_BEHALF_OF_AN_ENTITY && (
                      <div>
                        <div className="text-xl">{getValues('entityDetails.titleWithCompany')}</div>
                        <div className="">Title of Authorized Person for Subscriber</div>
                      </div>
                    )}

                    <div className="mt-2 text-xl">
                      {getValues('addressInfo.city')}, {getValues('addressInfo.state')},{' '}
                      {getValues('addressInfo.postalCode')}
                    </div>
                    <div className="">
                      {getValues('investingProfile.option') === InvestingPersonEnum.IN_BEHALF_OF_AN_ENTITY
                        ? 'City, State and Zip Code of Authorized Person '
                        : `Investor's City, State, Zip`}
                    </div>
                  </div>
                  <div className="mt-2 text-xl">
                    {(getValues('addressInfo.country') as string).toLowerCase() === 'usa'
                      ? maskSSN(getValues('financialInfo.ssn'))
                      : maskNumbersExceptLastFour(getValues('financialInfo.tin'))}{' '}
                  </div>
                  <div className="">
                    {getValues('investingProfile.option') === InvestingPersonEnum.IN_BEHALF_OF_AN_ENTITY
                      ? 'Social Security Number of Authorized Person'
                      : `Investor's ` +
                        ((getValues('addressInfo.country') as string).toLowerCase() === 'usa'
                          ? 'Social Security Number'
                          : 'Tax Identification Number')}
                  </div>
                </div>
              )}

              {getValues('investingProfile.option') === InvestingPersonEnum.RETIREMENT &&
                getValues('investingProfile.retirementAccountType') === 'TRUST_ACCOUNT' && (
                  <div>
                    <div>
                      <div className="mt-6 text-xl font-bold">AUTHORIZED PERSON</div>
                      <div className="mt-2 font-alexBrush text-4xl font-bold">
                        {getValues('basicInfo.firstName')} {getValues('basicInfo.middleName')}{' '}
                        {getValues('basicInfo.lastName')} {getValues('basicInfo.suffix')}
                      </div>
                      <div>Authorized Person Signature</div>
                    </div>
                    <div className="mt-4">
                      <div className="text-xl">
                        {getValues('basicInfo.firstName')} {getValues('basicInfo.middleName')}{' '}
                        {getValues('basicInfo.lastName')} {getValues('basicInfo.suffix')}
                      </div>
                      <div className="">Printed Name of Authorized Person</div>

                      <div className="mt-2 text-xl">{getValues('addressInfo.Street1')}</div>
                      <div className="">Street Address of Authorized Person </div>

                      <div className="mt-2 text-xl">
                        {getValues('addressInfo.city')}, {getValues('addressInfo.state')},{' '}
                        {getValues('addressInfo.postalCode')}
                      </div>
                      <div className="">City, State and Zip Code of Authorized Person </div>

                      <div className="mt-2 text-xl">
                        {(getValues('addressInfo.country') as string).toLowerCase() === 'usa'
                          ? maskSSN(getValues('financialInfo.ssn'))
                          : maskNumbersExceptLastFour(getValues('financialInfo.tin'))}{' '}
                      </div>
                      <div className="">
                        {(getValues('addressInfo.country') as string).toLowerCase() === 'usa'
                          ? 'Social Security Number'
                          : 'Tax Identification Number'}{' '}
                        of Authorized Person
                      </div>
                    </div>
                  </div>
                )}

              {getValues('investingProfile.option') === InvestingPersonEnum.RETIREMENT &&
                getValues('investingProfile.retirementAccountType') === RetirementAccountEnum.RETIREMENT_ACCOUNT && (
                  <div>
                    <div>
                      <div className="mt-6 text-xl font-bold">RETIREMENT ACCOUNT HOLDER </div>
                      <div className="mt-2 font-alexBrush text-4xl font-bold">
                        {getValues('basicInfo.firstName')} {getValues('basicInfo.middleName')}{' '}
                        {getValues('basicInfo.lastName')} {getValues('basicInfo.suffix')}
                      </div>
                      <div>Signature of Retirement Account Holder</div>
                    </div>
                    <div className="mt-4">
                      <div className="text-xl">
                        {getValues('basicInfo.firstName')} {getValues('basicInfo.middleName')}{' '}
                        {getValues('basicInfo.lastName')} {getValues('basicInfo.suffix')}
                      </div>
                      <div className="">Printed Name of Retirement Account Holder</div>

                      <div className="mt-2 text-xl">{getValues('addressInfo.Street1')}</div>
                      <div className="">Street Address of Retirement Account Holder</div>

                      <div className="mt-2 text-xl">
                        {getValues('addressInfo.city')}, {getValues('addressInfo.state')},{' '}
                        {getValues('addressInfo.postalCode')}
                      </div>
                      <div className="">City, State and Zip Code of Retirement Account Holder</div>

                      <div className="mt-2 text-xl">
                        {(getValues('addressInfo.country') as string).toLowerCase() === 'usa'
                          ? maskSSN(getValues('financialInfo.ssn'))
                          : maskNumbersExceptLastFour(getValues('financialInfo.tin'))}{' '}
                      </div>
                      <div className="">
                        {(getValues('addressInfo.country') as string).toLowerCase() === 'usa'
                          ? 'Social Security Number'
                          : 'Tax Identification Number'}{' '}
                        of Retirement Account Holder
                      </div>
                    </div>
                  </div>
                )}

              {getValues('investingProfile.option') === InvestingPersonEnum.JOINTLY && (
                <div className="ml-60">
                  <div>
                    <div className="mt-6 text-xl font-bold">SUBSCRIBER</div>
                    <div className="mt-2 font-alexBrush text-4xl font-bold">
                      {getValues('secondary.basicInfo.firstName')} {getValues('secondary.basicInfo.middleName')}{' '}
                      {getValues('secondary.basicInfo.lastName')} {getValues('secondary.basicInfo.suffix')}
                    </div>
                    <div>Signature</div>
                  </div>
                  <div className="mt-2">
                    <div className="text-xl">
                      {getValues('secondary.basicInfo.firstName')} {getValues('secondary.basicInfo.middleName')}{' '}
                      {getValues('secondary.basicInfo.lastName')} {getValues('secondary.basicInfo.suffix')}
                    </div>
                    <div className="">Subscriber</div>

                    <div className="mt-2 text-xl">{getValues('secondary.addressInfo.Street1')}</div>
                    <div className="">Investor's Address</div>

                    <div className="mt-2 text-xl">
                      {getValues('secondary.addressInfo.city')}, {getValues('secondary.addressInfo.state')},{' '}
                      {getValues('secondary.addressInfo.postalCode')}
                    </div>
                    <div className="">Investor's City, State, Zip</div>

                    <div className="mt-2 text-xl">
                      {(getValues('secondary.addressInfo.country') as string).toLowerCase() === 'usa'
                        ? maskSSN(getValues('secondary.financialInfo.ssn'))
                        : maskNumbersExceptLastFour(getValues('secondary.financialInfo.tin'))}{' '}
                    </div>
                    <div className="">
                      Investor's{' '}
                      {(getValues('secondary.addressInfo.country') as string).toLowerCase() === 'usa'
                        ? 'Social Security Number'
                        : 'Tax Identification Number'}
                    </div>
                  </div>
                </div>
              )}
              {getValues('investingProfile.option') === InvestingPersonEnum.IN_BEHALF_OF_AN_ENTITY && (
                <div className="ml-60">
                  <div>
                    <div className="mt-6 text-xl font-bold">SUBSCRIBER COMPANY</div>
                    {/* <div className="mt-2">_____________________________</div>
                      <div>Signature</div> */}
                  </div>
                  <div className="mt-2">
                    <div className="text-xl">{getValues('entityDetails.companyName')}</div>
                    <div className="">Name of Company</div>

                    <div className="text-x mt-2">{getValues('entityDetails.addressInfo.street1')}</div>
                    <div className="">Street Address of Company</div>

                    <div className="mt-2 text-xl">
                      {getValues('entityDetails.addressInfo.city')}, {getValues('entityDetails.addressInfo.state')},{' '}
                      {getValues('entityDetails.addressInfo.postalCode')}
                    </div>
                    <div className="">City, State and Zip Code of Company</div>

                    <div className="text-x mt-2">{getValues('entityDetails.ein')}</div>
                    <div className="">EIN of Company</div>
                  </div>
                </div>
              )}

              {getValues('investingProfile.option') === InvestingPersonEnum.RETIREMENT &&
                getValues('investingProfile.retirementAccountType') === 'TRUST_ACCOUNT' && (
                  <div className="ml-60">
                    <div>
                      <div className="mt-6 text-xl font-bold">SUBSCRIBER TRUST</div>
                    </div>
                    <div className="mt-4">
                      <div className="text-xl">{getValues('entityDetails.name')}</div>
                      <div className="">Name of Trust</div>

                      <div className="mt-2 text-xl">{getValues('entityDetails.addressInfo.Street1')}</div>
                      <div className="">Street Address of Trust </div>

                      <div className="mt-2 text-xl">
                        {getValues('entityDetails.addressInfo.city')}, {getValues('entityDetails.addressInfo.state')},{' '}
                        {getValues('entityDetails.addressInfo.postalCode')}
                      </div>
                      <div className="">City, State and Zip Code of Trust </div>

                      <div className="mt-2 text-xl">{maskNumbersExceptLastFour(getValues('entityDetails.ein'))}</div>
                      <div className="">EIN/SSN of Trust</div>
                    </div>
                  </div>
                )}

              {getValues('investingProfile.option') === InvestingPersonEnum.RETIREMENT &&
                getValues('investingProfile.retirementAccountType') === RetirementAccountEnum.RETIREMENT_ACCOUNT &&
                getValues('entityDetails.authorized') === 'yes' && (
                  <div className="ml-36">
                    <div>
                      <div className="mt-6 text-xl font-bold">SUBSCRIBER RETIREMENT ACCOUNT CUSTODIAN </div>
                    </div>
                    <div className="mt-10 font-alexBrush text-4xl font-bold">
                      {/* {getValues('basicInfo.firstName')} {getValues('basicInfo.middleName')}{' '}
                        {getValues('basicInfo.lastName')} {getValues('basicInfo.suffix')} */}
                    </div>
                    <div className="">Authorized Signatory Signature (if necessary)</div>
                    <div className="mt-4">
                      <div className="text-xl">{getValues('entityDetails.name')}</div>
                      <div className="">Name of Retirement Account</div>

                      <div className="mt-2 text-xl">{getValues('entityDetails.addressInfo.Street1')}</div>
                      <div className="">Street Address of Retirement Account</div>

                      <div className="mt-2 text-xl">
                        {getValues('entityDetails.addressInfo.city')}, {getValues('entityDetails.addressInfo.state')},{' '}
                        {getValues('entityDetails.addressInfo.postalCode')}
                      </div>
                      <div className="">City, State and Zip Code of Retirement Account</div>

                      <div className="mt-2 text-xl">{maskNumbersExceptLastFour(getValues('entityDetails.ein'))}</div>
                      <div className="">EIN/SSN of Retirement Account</div>
                    </div>
                  </div>
                )}

              {getValues('investingProfile.option') === InvestingPersonEnum.RETIREMENT &&
                getValues('investingProfile.retirementAccountType') === RetirementAccountEnum.RETIREMENT_ACCOUNT &&
                getValues('entityDetails.authorized') === 'no' && (
                  <div className="ml-36">
                    <div>
                      <div className="mt-6 text-xl font-bold">SUBSCRIBER RETIREMENT ACCOUNT CUSTODIAN </div>
                    </div>
                    <div className="mt-8">Custodian Signature</div>
                    <div className="mt-4">
                      <div className="text-xl">{getValues('entityDetails.name')}</div>
                      <div className="">Name of Retirement Account</div>

                      <div className="mt-2 text-xl">{getValues('entityDetails.addressInfo.Street1')}</div>
                      <div className="">Street Address of Retirement Account</div>

                      <div className="mt-2 text-xl">
                        {getValues('entityDetails.addressInfo.city')}, {getValues('entityDetails.addressInfo.state')},{' '}
                        {getValues('entityDetails.addressInfo.postalCode')}
                      </div>
                      <div className="">City, State and Zip Code of Retirement Account</div>

                      <div className="mt-2 text-xl">{maskNumbersExceptLastFour(getValues('entityDetails.ein'))}</div>
                      <div className="">EIN/SSN of Retirement Account</div>
                    </div>
                  </div>
                )}
            </div>

            <div className="mt-8 flex">
              Number of shares: <p className="ml-3">{getValues('investingProfile.amount') / sharePrice}</p>
            </div>
            <div className="flex">
              Dollar Amount of Shares (At ${formatNumber(sharePrice)} per Share):{' '}
              <p className="ml-3">${(getValues('investingProfile.amount') / sharePrice) * sharePrice}</p>
            </div>

            <div className="flex flex-row justify-between">
              <div className="w-1/2">
                <div className="mt-4 text-xl">SUBSCRIPTION ACCEPTED:</div>
                <div className="mt-2"></div>
                <div>Armed Forces Brewing Company, Inc.</div>
                <div className="mt-6">_____________________________</div>
                <div>By: Alan Beal</div>
                <div>Chief Executive Officer</div>
              </div>

              <div className="flex w-1/2 flex-col justify-start">
                <div className="mt-4 text-xl">DATE:</div>
                <div className="mt-2"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SubscriptionAgreemenPdf
